import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const PHONE_NUMBER = "918308832896";

const CallButton = () => {
  return (
    <motion.a
      href={`tel:+${PHONE_NUMBER}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.7, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-24 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl transition-shadow"
      aria-label="Call Now"
    >
      <Phone className="w-7 h-7" />
    </motion.a>
  );
};

export default CallButton;